import { Pipe, PipeTransform } from '@angular/core';

const MB = 1048576;
const GB = 1073741824;

@Pipe({
  name: 'fileSize'
})
export class FileSizePipe implements PipeTransform {

  transform(size: number, type: string): string {
   return this.getFileSize(size, type);
  }

  private getFileSize(size: number, type: string): string {
    if (!size) return ''

    switch (type) {
      case 'MB':
        return (size / MB).toFixed(2).toString() + ' MB';
      case 'GB':
        return (size / GB).toFixed(2).toString() + ' GB';
    }
  }

}



// WEBPACK FOOTER //
// ./src/app/shared/pipes/file-size.pipe.ts